import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c(VProgressCircular,_vm._b({},'v-progress-circular',Object.assign({}, _vm.$attrs, _vm.propsToApply),false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }